import { render, staticRenderFns } from "./ModalMSDSFileChange.vue?vue&type=template&id=0af25c08&scoped=true&"
import script from "./ModalMSDSFileChange.vue?vue&type=script&lang=js&"
export * from "./ModalMSDSFileChange.vue?vue&type=script&lang=js&"
import style0 from "./ModalMSDSFileChange.vue?vue&type=style&index=0&id=0af25c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af25c08",
  null
  
)

export default component.exports